var render = function render(){var _vm=this,_c=_vm._self._c;return _c('injury-donut',{attrs:{"docs":_vm.docs,"field":"condition","colors":_vm.colors,"label-fn":_vm.injuryConditionLabel,"center-label":_vm.$t('statistics.distinct_particularities')}})
}
var staticRenderFns = []

export { render, staticRenderFns }